import { render, staticRenderFns } from "./EditInstructorsPage.vue?vue&type=template&id=d5d1ba52&scoped=true"
import script from "./EditInstructorsPage.vue?vue&type=script&lang=ts"
export * from "./EditInstructorsPage.vue?vue&type=script&lang=ts"
import style0 from "./EditInstructorsPage.vue?vue&type=style&index=0&id=d5d1ba52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5d1ba52",
  null
  
)

export default component.exports